import { Link } from "react-router-dom";
import { TmaisUserData } from "../types/tmaisUsers.type";
import Button from "@/common/components/Button";
import { ArrowBigRight } from "lucide-react";

export class TmaisUsersTransformer {
  static tableTransformer() {
    return (tmaisUsers: TmaisUserData[]) => {
      return tmaisUsers.map((tmaisUser) => {
        return {
          ...tmaisUser,
          action: (
            <Link to={tmaisUser.id}>
              <Button name="access_tmais_user_button" variant='link-white' className="w-full" operationKlassToCheckPermission="Establishment::Tmais::Users::Show">
                <ArrowBigRight />
              </Button>
            </Link>
          )
        };
      });
    };
  }
}
